import { isPlatformBrowser } from '@angular/common';
import {
  ApplicationRef,
  inject,
  Injectable,
  PLATFORM_ID,
  TransferState,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAuthToken } from '../store/reducers';

@Injectable({
  providedIn: 'root',
})
export class ServerRenderedDataService {
  private authToken = inject(Store).selectSignal(selectAuthToken);
  private isHydratingServerRenderedPage =
    isPlatformBrowser(inject(PLATFORM_ID)) && !inject(TransferState).isEmpty;

  constructor() {
    if (this.isHydratingServerRenderedPage) {
      inject(ApplicationRef)
        .whenStable()
        .then(() => (this.isHydratingServerRenderedPage = false));
    }
  }

  /**
   * Le serveur rend le catalogue sans session : un utilisateur connecté doit
   * recharger les réponses qui dépendent de son compte.
   */
  mustReloadWithSession(): boolean {
    return this.isHydratingServerRenderedPage && !!this.authToken();
  }
}
